import { render, staticRenderFns } from "./ConfigBuilder.vue?vue&type=template&id=bd2aac28&"
import script from "./ConfigBuilder.vue?vue&type=script&lang=js&"
export * from "./ConfigBuilder.vue?vue&type=script&lang=js&"
import style0 from "./ConfigBuilder.vue?vue&type=style&index=0&id=bd2aac28&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports